
import '../scss/style.scss';

// SEARCH

function openSearch() {
    var searchForm = document.getElementById("navSearchForm");

    if (searchForm) {
        searchForm.style.height = "100px";
    }
}
window.openSearch = openSearch;

function closeSearch() {
    var searchForm = document.getElementById("navSearchForm");

    if (searchForm) {
        searchForm.style.height = "0%";
    }
}
window.closeSearch = closeSearch;


$( ".search-link" ).click(function(e) {
    e.preventDefault();
    openSearch();
});

$( ".search-link-container .closebtn" ).click(function(e) {
    e.preventDefault();
    closeSearch();
});

$( ".search-form" ).submit(function() {
    closeSearch();
});

$(document).click(function(e) {
    var container = $(".search-link-container");

    if (!container.is(e.target) && container.has(e.target).length === 0) {
        closeSearch();
    }
});
